export default "__VITE_ASSET__DyJxZAkZ__"